export class Currency {
    /**
     * @param number {Number}
     */
    static format(number, decimal = 2) {
        const numberFormat = new Intl.NumberFormat('en-MX', { style: 'decimal', currency: 'MXN', minimumFractionDigits: decimal, maximumFractionDigits: decimal })
        return numberFormat.format(number);
    }
}
